module.exports = __webpack_public_path__ + "img/profile-woman-7-min.92c140ec.jpg";